import { useEffect, useRef } from 'react';
import JSONEditor from 'jsoneditor';
import 'jsoneditor/dist/jsoneditor.min.css';
import { safeParseJson } from '../../lib';
interface IProps {
  readonly id: string;
  readonly height: number;
  readonly width?: number;
  readonly json?: Object;
  readonly clearWhenWrongFormat?: boolean;
  readonly onChange?: (jsonStr?: Object) => void;
  readonly onError?: (error: any) => void;
  readonly mode?: 'tree' | 'text' | 'code' | 'preview';
}

export const ReactJsonEditor = (props: IProps) => {
  const editor = useRef<any>();
  const isInit = useRef<boolean>(false);

  const onChange = () => {
    if (editor.current && props?.onChange) {
      const text = editor.current.getText();
      if (safeParseJson(text)) {
        props.onChange(editor.current.get());
      } else if (props.clearWhenWrongFormat) {
        props.onChange(undefined);
      }
    }
  };

  useEffect(() => {
    if (props.id) {
      const container = document.querySelector(`#${props.id}`);
      const options = {
        onChange,
        onError: props?.onError,
        mode: props.mode || 'code',
      };
      editor.current = new JSONEditor(container as HTMLElement, options);
    }
  }, [props.id]);

  useEffect(() => {
    if (isInit.current) {
      return;
    }

    setTimeout(() => {
      isInit.current = true;
    }, 500);

    if (editor.current && props.json) {
      editor.current.set(props.json);
    }
  }, [JSON.stringify(props.json)]);

  return (
    <div
      id={props.id}
      style={{ height: props.height, width: props.width }}
    ></div>
  );
};
